var $ab3b62ef853668f6$exports = {};
$ab3b62ef853668f6$exports = {
    "endTime": `Beigu laiks`,
    "startTime": `S\u{101}kuma laiks`,
    "time": `Laiks`
};


export {$ab3b62ef853668f6$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
